'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp2;

var _mobx = require('mobx');

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

var _projectEntity = require('project-entity');

var _configurationEntity = require('configuration-entity');

var _typeEntity = require('type-entity');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SystemContentModel = exports.SystemContentModel = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.ref, _dec4 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(SystemContentModel, _BaseContentModel);

  function SystemContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SystemContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SystemContentModel.__proto__ || (0, _getPrototypeOf2.default)(SystemContentModel)).call.apply(_ref, [this].concat(args))), _this), _this.guid = "Synthetic", _this.readonly = true, _this.savable = false, _this.FullEditor = _editor2.default, _initDefineProp(_this, 'types', _descriptor, _this), _initDefineProp(_this, 'configuration', _descriptor2, _this), _initDefineProp(_this, 'project', _descriptor3, _this), _initDefineProp(_this, 'icon', _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SystemContentModel, [{
    key: 'publishEntities',
    value: function publishEntities(_ref2) {
      var cm = _ref2.cm,
          _ref2$path = _ref2.path,
          path = _ref2$path === undefined ? "entities" : _ref2$path,
          cb = _ref2.cb,
          _ref2$addConfigs = _ref2.addConfigs,
          addConfigs = _ref2$addConfigs === undefined ? true : _ref2$addConfigs,
          _ref2$outputToString = _ref2.outputToString,
          outputToString = _ref2$outputToString === undefined ? false : _ref2$outputToString;

      var simgate = this.$parent.simgate;
      var addEnts = [cm];

      if (addConfigs) {
        var Configuration = this.$parent.entities.get("Configuration");
        var Project = this.$parent.entities.get("Project_FlowEditor");
        if (Configuration !== cm) addEnts.push(Configuration);
        if (Project !== cm) addEnts.push(Project);
      }

      var serializedEntities = cm.getAllChildEntitiesFiltered(function (ent) {
        return ent.Synthetic !== true && ent.constructor.Synthetic !== true && ent.savable !== false && ent.constructor.savable !== false && addEnts.indexOf(ent) === -1;
      }).concat(addEnts).map(function (ent) {
        return ent.simboxDTO;
      });

      if (outputToString) return (0, _stringify2.default)(serializedEntities, null, 2);
      debugger;

      simgate.config.update({
        path: path + "://entities",
        set: serializedEntities
      }).then(function () {
        return simgate.config.commit({
          path: path
        }).then(function () {
          if (cb) cb();else alert("success publishing entities!  you may now build and push to stage / prod");
        });
      });
    }
  }]);
  return SystemContentModel;
}(_baseContentmodel2.default), _class2.Synthetic = true, _class2._slots = {
  types: [_typeEntity.ContentModel],
  configuration: _configurationEntity.ContentModel,
  project: _projectEntity.ContentModel,
  icon: ""
}, _class2._meta = {
  types: {
    readonly: true
  }
}, _class2.id = "System", _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'types', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'configuration', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'project', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "system-icon";
  }
}), _applyDecoratedDescriptor(_class.prototype, 'publishEntities', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'publishEntities'), _class.prototype)), _class));
var _default = SystemContentModel;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SystemContentModel, 'SystemContentModel', 'src/entity_modules/system-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/system-entity/contentmodel.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/system-entity/contentmodel.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/system-entity/contentmodel.js
// module chunks = 0